import PropTypes from 'prop-types';

const CommentLoading = ({ displayPost, className = 'p-5' }) => {
    return (
        <div
            className={`mb-3 flex rounded-md bg-white dark:bg-icoDarkMode-anthracite ${className}`}>
            {displayPost ? (
                <div className="animate-pulse pr-5">
                    <span className="block h-14 w-14 overflow-hidden rounded-sm bg-icoGray-300 dark:bg-icoDarkMode-deepBlack"></span>
                </div>
            ) : null}
            <div className="flex-1 animate-pulse">
                <div className="mb-2 flex items-center">
                    <span className="block h-5 w-5 rounded-full bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                    <div className="ml-2 block w-1/3 rounded bg-icoGray-300 py-1.5 dark:bg-icoDarkMode-deepBlack"></div>
                </div>
                <div className="mb-2 block w-full rounded bg-icoGray-300 py-1.5 dark:bg-icoDarkMode-deepBlack"></div>
                <div className="block w-5/6 rounded bg-icoGray-300 py-1.5 dark:bg-icoDarkMode-deepBlack"></div>
                <div className="mt-4 flex space-x-3">
                    <span className="mb-2 block w-15 rounded bg-icoGray-300 py-1 dark:bg-icoDarkMode-deepBlack"></span>
                    <span className="mb-2 block w-15 rounded bg-icoGray-300 py-1 dark:bg-icoDarkMode-deepBlack"></span>
                    <span className="mb-2 block w-15 rounded bg-icoGray-300 py-1 dark:bg-icoDarkMode-deepBlack"></span>
                    <span className="mb-2 block w-15 rounded bg-icoGray-300 py-1 dark:bg-icoDarkMode-deepBlack"></span>
                </div>
            </div>
        </div>
    );
};

CommentLoading.propTypes = {
    displayPost: PropTypes.bool,
    className: PropTypes.string
};

export default CommentLoading;
